import { type WebSection } from '@wbk/contentful/api';
import ErrorBoundary from '../error/ErrorBoundary';
import ZoneCategories from '../zones/Categories';
import EventSection from '../sections/zones/EventSection';
import ExperiencesSection from '../sections/zones/Expericences';
import Zones from '../sections/zones/Zones';

import WorldSection from '../zones/world/WorldSection';
import CountriesCard from '../sections/zones/CountriesCard';
import Discover from '../sections/zones/Discover';
import EventsFullScreenCarousel from '../sections/common/FeaturedEvents';

const ZonesDetailsSections = ({ section }: { section?: WebSection }) => {
  switch (section?.renderType) {
    case 'cards-grid':
      return <EventSection section={section} />;
    case 'fullwidth-carousel':
      return <EventsFullScreenCarousel section={section} />;
    case 'anchors':
      return (
        <ErrorBoundary fallback={<></>}>
          <CountriesCard section={section} />
        </ErrorBoundary>
      );
    case 'whats-new':
      return (
        <ErrorBoundary fallback={<></>}>
          <Discover section={section} />
        </ErrorBoundary>
      );
    case 'grid':
      return (
        <ErrorBoundary fallback={<></>}>
          <ExperiencesSection section={section} />
        </ErrorBoundary>
      );
    case 'spotlight':
      return (
        <ErrorBoundary fallback={<></>}>
          <WorldSection section={section} />
        </ErrorBoundary>
      );
    case 'category':
      return (
        <ErrorBoundary fallback={<></>}>
          <ZoneCategories section={section} />
        </ErrorBoundary>
      );
    case 'recap':
      return (
        <ErrorBoundary fallback={<></>}>
          <Zones section={section as WebSection} />
        </ErrorBoundary>
      );
    default:
      return;
  }
};

export default ZonesDetailsSections;
